<template>
  <div class="view-pdf" :class="{ opacity: loading }">
    <iframe
      v-show="previewUrl"
      id="ifra"
      ref="Iframe"
      frameborder="0"
      :src="`${previewUrl}?fileId=${fileId}&token=${previewToken}`"
      width="100%"
      style="height: 100%"
    >
    </iframe>
  </div>
</template>

<script>
import courseCenterApi from '@/request/courseCenter/courseCenterApi.js';
export default {
  data() {
    return {
      previewUrl: '',
      fileId: '',
      previewToken: '',
      downToken: '',
      downUrl: '',
      show: false,
      studentName: '',
      gradeClassName: '',
      orgName: '',
      signId: '',
      loading: true
    };
  },
  computed: {
    titleStr() {
      return `服务签约详情(${this.studentName}_${this.gradeClassName}_${this.orgName})`;
    }
  },
  created() {

  },
  mounted() {
    // this.beforeLoad();
    this.iframeLoad();
  },
  methods: {
    // 下载token
    async getDownloadtoken(fileId) {
      this.fileId = fileId;
      const params = {
        fileId: [fileId],
        type: 1
      };
      this.$Spin.show();
      // const res = await cateringAdmin.getDownloadtoken(params);
      const res = await courseCenterApi.getPreviewServicePdfApi({
        fileId: fileId
      });
      this.$Spin.hide();
      if (res.status == 200) {
        // this.downUrl = res.message.downUrl
        this.previewUrl = res.message.previewUrl;
        this.previewToken = res.message.token;

        // this.downToken = res.message.token
      }
      this.show = true;
    },
    beforeLoad() {
      const hasLoaded1 = document.getElementById('iframeLoad');
      if (hasLoaded1) {
        return;
      }
      const meta = document.createElement('meta');
      meta['http-equiv'] = 'Content-Security-Polic';
      meta.content = 'upgrade-insecure-requests';
      meta.id = 'iframeLoad';
      document.head.appendChild(meta);
    },
    // iframe
    iframeLoad() {
      const iframe = document.querySelector('#ifra');
      // 兼容处理;
      if (iframe.attachEvent) {
        // IE
        iframe.attachEvent('onload', () => {
          this.loading = false;
        });
      } else {
        // 非IE

        iframe.onload = () => {
          this.loading = false;
        };
      }
    },
    async handleInit(fileId) {
      this.getDownloadtoken(fileId);
    }
    // async handleShow(row) {
    //   const { studentName, gradeClassName, orgName, signId } = row;
    //   this.studentName = studentName;
    //   this.gradeClassName = gradeClassName;
    //   this.orgName = orgName;
    //   this.signId = signId;
    //   this.getDownloadtoken(row.signFileId);
    // }
  }
};
</script>

<style  lang="scss" scoped>
.view-pdf {
  height: 400px;
  position: relative;
  width: 800px;
  margin-bottom: 20px;
  .iframe-main {
    height: 100%;
    position: relative;
  }
  .opacity {
    opacity: 0;
  }
  .modal-footer {
    text-align: right;
    padding: 10px 0;
  }
}
</style>
